import 'src/styles/ui/badge-row.css';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * A wrapping row of status badges / pills — gapped and vertically centered.
 * Pass `center` to horizontally center the row. Generic — usable by any feature.
 */
const BadgeRow = ({ center, children, className, ...props }) => (
  <div className={classNames('badge-row', { 'badge-row--center': center }, className)} {...props}>
    {children}
  </div>
);

BadgeRow.propTypes = {
  center: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

BadgeRow.defaultProps = { center: false, children: null, className: '' };

export default BadgeRow;
